/*
 * Ariser: side arrows for the category strip (.ariser-category-strip).
 *
 * The strip is a native horizontal scroller (see custom.css.liquid). On
 * tablet/desktop this adds a previous/next button that scrolls the row by
 * one screen, and hides each button when there is nothing more to scroll
 * in that direction. Phones scroll by touch and get no arrows.
 */
(function () {
  'use strict';

  var ICON_PREV = '<svg width="9" height="12" viewBox="0 0 7 10" fill="none" aria-hidden="true"><path d="M5.5 9L1.5 5l4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg width="9" height="12" viewBox="0 0 7 10" fill="none" aria-hidden="true"><path d="M1.5 9l4-4-4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeButton(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ariser-strip-arrow ariser-strip-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Previous categories' : 'More categories');
    b.innerHTML = dir === 'prev' ? ICON_PREV : ICON_NEXT;
    return b;
  }

  function setup(strip) {
    var row = strip.querySelector('.sf-mixed-layout__wrapper');
    var host = strip.querySelector('.collection-list__wrapper') || strip.querySelector('.collection-list__inner');
    if (!row || !host || host.querySelector('.ariser-strip-arrow')) return;

    var prev = makeButton('prev');
    var next = makeButton('next');
    host.appendChild(prev);
    host.appendChild(next);

    function step() { return Math.max(row.clientWidth * 0.8, 120); }
    prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });

    function update() {
      var max = row.scrollWidth - row.clientWidth;
      var overflow = max > 2 && window.innerWidth >= 768;
      prev.disabled = !overflow || row.scrollLeft <= 2;
      next.disabled = !overflow || row.scrollLeft >= max - 2;
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(row);
    update();
    // images load lazily and change the row's scroll width
    setTimeout(update, 600);
    setTimeout(update, 2000);
  }

  function init() {
    document.querySelectorAll('.ariser-category-strip').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme editor re-renders the section when settings change
  document.addEventListener('shopify:section:load', init);
})();
